module.exports = __webpack_public_path__ + "static/media/welcome.57508305.mp3";